export default "__VITE_ASSET__DY9s_44x__"